import {
  IMeetingFolderCreatePayload,
  IMeetingFolderUpdatePayload,
} from '../../page/page-storage/meeting-folder/meeting-folder.types';
import { IMeetingFolder } from '../../resource/meeting-folder/meeting-folder.types';
import { IApiRequestConfig } from '../api.types';

export const fetchMeetingFoldersApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'fetchMeetingFolders',
  uri: 'json',
  action: 'meeting-folders',
  method: 'get',
  v2: true,
});

export const createMeetingFolderApi = (payload: IMeetingFolderCreatePayload): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createMeetingFolder',
  uri: 'json',
  action: `meeting-folders`,
  method: 'post',
  data: payload,
  v2: true,
});

export const updateMeetingFolderApi = (
  meetingFolderId: string,
  payload: IMeetingFolderUpdatePayload,
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateMeetingFolder',
  uri: 'json',
  action: `meeting-folders/${meetingFolderId}`,
  method: 'patch',
  data: payload,
  v2: true,
});

export const deleteMeetingFolderApi = (meetingFolderId: IMeetingFolder['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteMeetingFolder',
  uri: 'json',
  action: `meeting-folders/${meetingFolderId}`,
  method: 'delete',
  v2: true,
});
